import { useRouter } from 'next/router'
import * as style from './style'
import { MessageType, useAi } from '@/context/ai'
import { useState } from 'react'
import { AIElementNames, eventsTracker } from '@/lib/eventsTracker'

interface Props {
  id?: string
  className?: string
}

const HelenSearchSection = ({ id, className = '' }: Props): JSX.Element => {
  const router = useRouter()
  const { dispatch } = useAi()
  const [searchQuery, setSearchQuery] = useState('')

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setSearchQuery(e.target.value)
  }

  const handleSubmit = (): void => {
    if (!searchQuery.trim()) return // Prevent submission if searchQuery is empty
    eventsTracker.handleOnClickAndTrackEvent(AIElementNames.BUTTON_SEND_MESSAGE)
    dispatch({ type: 'UPDATE', payload: { query: searchQuery, messageType: MessageType.UserFreeText } })
    router.push(`/helen`)
  }
  return (
    <section id={id ?? undefined} className={`${className} px-0 py-3 md:py-6`}>
      <h2 className={`${style.heading} leading-7 mb-1`}>What can I help you with today?</h2>
      <p className={`${style.subHeading} text-primary`}>
        Helen is a digital assistant and can help you with answers, finding classes, organize your day and more.
      </p>
      <div
        className={`${style.inputContainer} mt-4 flex pl-5 rounded-[48px] w-full border-2 border-[#EAEAEF] items-center bg-[#F7F7FA] h-[42px]`}
      >
        <div className="flex items-center w-full">
          <input
            autoComplete="off"
            placeholder="Ask me anything"
            type="text"
            onChange={handleOnChange}
            className="m-2 w-full border-none focus:outline-none focus:ring-0 bg-[#F7F7FA] placeholder-[--gsu-black80] placeholder:text-sm xxl:text-base xxl:placeholder:text-base xxxl:placeholder:text-2xl xxxl:text-2xl"
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                handleSubmit()
              }
            }}
          />
        </div>
        <button
          className={`${style.button} bg-secondary px-4 py-2 rounded-[40px] text-sm font-semibold text-white h-10 w-20`}
          onClick={() => handleSubmit()}
        >
          Submit
        </button>
      </div>
    </section>
  )
}

export default HelenSearchSection
